import yup from 'utils/yup';

export const initialDataExportsFormData = {
  user_id: '' as any,
  date_range: [null, null] as any,
};

export const dataExportsValidationSchema = yup.object().shape({
  user_id: yup.string().required(),
  date_range: yup.array().of(yup.string().min(2, 'This is required').required('this is required')),
});

export const initialJobDataExportsFormData = {
  job_status: null as any,
};

export const jobDataExportsValidationSchema = yup.object().shape({
  job_status: yup.boolean().notRequired(),
});

export const initialUserDataExportsFormData = {
  active: null as any,
};

export const userDataExportsValidationSchema = yup.object().shape({
  active: yup.boolean().notRequired(),
});
